export default __webpack_public_path__ + "static/media/padel-wilson.2d81a435.png";